import * as $ from "jquery";
import imkt from '../../imkt';

imkt.wac.Home = class Home {
  $domRoot: HTMLElement;
  params: {};
  slideUpTrigger: JQuery<HTMLImageElement>;
  imageMidPoint: any;
  windowHeight: any;
  resizeTimer: any;
  customerBreakPoint: number;
  
  constructor(domRoot: HTMLElement, params: {}) {
    (this.$domRoot = domRoot || $("body")), (this.params = { ...params });

    // Image animation
    this.slideUpTrigger = $(".products__image").find("img");
    this.imageMidPoint;
    this.windowHeight;
    this.resizeTimer;
    this.customerBreakPoint = 800;
    this.init();
  }

  init() {
    var self = this;
    this.resize();
    this.customerInfo();

    // wait for images to load
    $(window).load(function () {
      self.customerBlocks();
    });
    if ($(window).width() > 800 && this.isMobile() === false) {
      this.scrollingAnimation();
    }
    this.ellipsis();
  }

  async ellipsis() {
    await import("jquery-migrate");
    await import("jquery-dotdotdot/src/jquery.dotdotdot.js");
    $(".customer-info .ellipsis h3").dotdotdot();
  }

  resize() {
    var self = this;
    $(window).on("resize", function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () {
        self.windowHeight = window.innerHeight;
        self.customerBlocks();
        self.ellipsis();
      }, 50);
    });
  }

  customerBlocks() {
    var blockShort = ".height-short",
      blockTall = ".height-tall";
    $(blockShort + "," + blockTall).height("auto");
    this.equalHeights(blockShort);
    this.equalHeights(blockTall);
  }

  equalHeights(className: string) {
    var self = this;
    var newHeight = 0;
    var el = $(className);
    $.each(el, function () {
      var height = $(this).height();
      if (window.innerWidth > self.customerBreakPoint) {
        if (height > newHeight) {
          newHeight = height;
        }
      } else {
        newHeight = "auto";
      }
    });
    el.height(newHeight);
  }

  imageSlideUp() {
    var self = this;
    this.imageMidPoint = this.slideUpTrigger.outerHeight() / 2;
    this.windowHeight = window.innerHeight;
    new Waypoint({
      element: self.slideUpTrigger,
      handler() {
        self.slideUpTrigger.addClass("slide-up");
      },
      offset: self.windowHeight - self.imageMidPoint,
    });
  }

  customerInfo() {
    $(".customer-info").hover(
      function () {
        $(this).addClass("active");
      },
      function () {
        $(this).removeClass("active");
      }
    );
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  // adg3 test
  scrollingAnimation() {
    var plane1 = {
      container: {
        "data-0": "transform: rotate(0deg)",
        "data-800": "transform: rotate(-25deg)",
      },
      image: {
        "data-0": "transform: translate3d(0px, 0px, 0)",
        "data-1100": "transform: translate3d(800px, -400px, 0)",
      },
    };
    var plane2 = {
      container: {
        "data-0": "transform: rotate(0deg)",
        "data-1600": "transform: rotate(60deg)",
      },
      image: {
        "data-0": "transform: translate3d(0px, 0px, 0)",
        "data-1600": "transform: translate3d(1600px, 200px, 0)",
      },
    };
    var plane3 = {
      container: {
        "data-0": "transform: rotate(0deg)",
        "data-1200": "transform: rotate(-20deg)",
      },
      image: {
        "data-0": "transform: translate3d(0px, 0px, 0)",
        "data-1200": "transform: translate3d(900px, -100px, 0)",
      },
    };
    $("#plane1").attr(plane1.container);
    $("#plane1 img").attr(plane1.image);
    $("#plane2").attr(plane2.container);
    $("#plane2 img").attr(plane2.image);
    $("#plane3").attr(plane3.container);
    $("#plane3 img").attr(plane3.image);
    var s = skrollr.init({ smoothScrolling: true });
    setTimeout(function () {
      s.refresh();
    }, 50);
  }
}

new imkt.wac.Home();
